(function(){
'use strict';

angular.module('classy').component('froalaField', {
  template: '\n    <div class="froala-field form_field full">\n      <form-label\n      required="$ctrl.required"\n      _spec="label">\n        {{:: $ctrl.label }}\n      </form-label>\n\n      <div class="form__sublabel"\n      ng-if="$ctrl.sublabel">\n        {{::$ctrl.sublabel}}\n      </div>\n\n      <div class="{{:: $ctrl.wrapperClass }}"\n      sc-error-class="$ctrl.name"\n      _spec="wrapper" data-ng-class="{ \'admin-body__lock-field form__text-input__outer\': $ctrl.lockField }" >\n      <div ng-if="$ctrl.lockField"\n          data-sc-tooltip-class="admin-campaign-tooltip lock-tooltip-msg"\n          data-sc-tooltip-position="center"\n          data-sc-tooltip-position-tip="bottom center"\n          show-event="\'mouseenter\'" hide-event="\'mouseout\'"\n          fixed-tooltip="true"\n          data-sc-tooltip="\'This field is locked at the template level.\'"\n          class="admin-body__tooltip-element"\n      ></div>\n\n        <textarea\n        data-ng-model="$ctrl.modelGetterSetter"\n        ng-model-options="{ getterSetter: true }"\n        data-parse-merge-tags="$ctrl.parseMergeTags"\n        data-alt-ng-model="$ctrl.altModel"\n        ng-required="$ctrl.required"\n        sc-validity-reporter\n        sc-validity-classes\n        data-froala="$ctrl.froalaOptions"\n        name="{{:: $ctrl.name }}"\n        ng-change="$ctrl.onChange()"\n        qa-id="{{:: $ctrl.scQaId.textAreaField }}"\n        _spec="input"></textarea>\n\n        <!-- Merge Tag Tooltip Template -->\n        <div ng-if="$ctrl.parseMergeTags" class="mergeTagStaging">\n          <merge-tag-tooltip message="$ctrl.mergeTagMsg"></merge-tag-tooltip>\n        </div>\n      </div>\n\n      <div data-ng-class="{ \'admin-body__lock-field form__text-input__outer\': $ctrl.lockCheckboxField }">\n      <div data-ng-style="{width: $ctrl.customStyle}" ng-if="$ctrl.lockCheckboxField"\n          data-sc-tooltip-class="admin-campaign-tooltip lock-tooltip-msg lock-tooltip-top-froala"\n          data-sc-tooltip-position="right"\n          data-sc-tooltip-position-tip="bottom center"\n          show-event="\'mouseenter\'" hide-event="\'mouseout\'"\n          fixed-tooltip="true"\n          data-sc-tooltip="\'This field is locked at the template level.\'"\n          class="admin-body__tooltip-element"\n      ></div>\n      <checkbox-control ng-if="$ctrl.checkboxModel !== undefined"\n        ng-model="$ctrl.checkboxModel"\n        flipped="$ctrl.checkboxFlipped">{{:: $ctrl.checkboxLabel }}</checkbox-control>\n      </div>\n\n      <form-error\n      name="$ctrl.name"\n      messages="$ctrl.errorMessages"\n      _spec="errors"></form-error>\n    </div>\n    ',
  bindings: {
    froalaOptions: '<',
    label: '<',
    model: '=',
    name: '<',
    onChange: '&?',
    errorMessages: '<?',
    required: '<?',
    wrapperClass: '<?',
    lockField: '<?',
    sublabel: '<?',
    checkboxLabel: '<?',
    checkboxFlipped: '<?',
    checkboxModel: '=?',

    // mergeTags support
    parseMergeTags: '<?',
    mergeTagMsg: '=?',
    altModel: '=?'
  },
  controller: ["scQaId", "$element", "$attrs", "$window", "scCampaignsTemplateService", "$stateParams", function FroalaFieldCtrl(scQaId, $element, $attrs, $window, scCampaignsTemplateService, $stateParams) {
    var _this = this;

    var DEFAULTS = {
      errorMessages: {
        required: 'This field is required.'
      },
      getterSetter: false,
      required: false
    };
    // tmpModel used for when the field is locked and we don't want the
    // automatic changes applied by froala widget into the actual model.
    var tmpModel = void 0;
    this.scQaId = scQaId;

    this.$onInit = function () {
      _this.lockField = _this.lockField || false;
      _this.lockCheckboxField = false;
      _this.customStyle = '';

      // Locking Setup for Details -> Donation Page
      if ($attrs.model === '$ctrl.campaign.classy_mode_appeal') {
        _this.lockField = scCampaignsTemplateService.getCampaignCustomizationLock('classy_mode_appeal');
      }
      if (SC.campaign && SC.campaign.campaignTemplateData) {
        if ($attrs.model === 'thisBlock.properties.preheaderText__withMergeTag') {
          _this.lockField = _.get(SC.campaign.campaignTemplateData, 'components.message.component_items[0].item_attributes.blocks[0].locked', false);

          var urlParams = window.location.pathname.split('/');
          var urlParamId = urlParams[urlParams.length - 2];
          var componentSetCampaign = 0;

          SC.campaign.campaignTemplateData.component_set_instances.forEach(function (item, idx) {
            if (item.campaign_id === SC.campaign.id) {
              componentSetCampaign = idx;
            }
          });

          var foundEmailId = _.filter(SC.campaign.campaignTemplateData.component_set_instances[componentSetCampaign].component_instances.message, function (data) {
            return data.id === urlParamId;
          });

          if (foundEmailId && foundEmailId[0] && foundEmailId[0].component_item_id) {
            var foundCurrentEmail = _.filter(SC.campaign.campaignTemplateData.components.message.component_items, function (data) {
              return data._id === foundEmailId[0].component_item_id.$oid;
            });

            /**
             * TODO: move this out of the first model check
             */
            if ($attrs.model === 'message.template_properties.subject__withMergeTags') {
              _this.lockField = _.get(foundCurrentEmail[0], 'item_attributes.template_properties.subject.locked', false);
            }
          }
        }

        /**
         * Template Locks for Email Content Message Heading (headline)
         */
        var chosenParamId = scCampaignsTemplateService.fetchCurrentBlockId($window);

        if ($attrs.model === 'thisBlock.properties.text__withMergeTags' || $attrs.model === 'thisBlock.properties.helpText__withMergeTags' || $attrs.model === 'thisBlock.properties.textBlock__withMergeTags' || $attrs.model === 'thisBlock.properties.appealMessage__withMergeTags' || $attrs.model === 'thisBlock.properties.message__withMergeTags') {
          var activeEmail = null;
          var foundEmailPayload = scCampaignsTemplateService.getEmailComponent(chosenParamId);
          activeEmail = scCampaignsTemplateService.getActiveEmail(foundEmailPayload);
          if (activeEmail) {
            var combinedBlocks = scCampaignsTemplateService.combineBlocks(activeEmail);
            _.forEach(combinedBlocks, function (value) {
              if (value.blockProp && value.blockProp.name === 'commitment-achieved') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'chargeback') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'commitment-updated') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'fundraising-commitment-waived') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'p2p-body') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'text') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'heading') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'rwf-claim') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'rwf-receipt') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'rwf-receipt-summary') {
                _this.lockField = value.locked;
              }
            });
          }
        }

        if ($attrs.model === 'thisBlock.properties.supportingMessage__withMergeTags' || $attrs.model === 'thisBlock.properties.headline__withMergeTags') {
          var _activeEmail = null;
          var _foundEmailPayload = scCampaignsTemplateService.getEmailComponent(chosenParamId);
          _activeEmail = scCampaignsTemplateService.getActiveEmail(_foundEmailPayload);
          if (_activeEmail) {
            var _combinedBlocks = scCampaignsTemplateService.combineBlocks(_activeEmail);
            _.forEach(_combinedBlocks, function (value) {
              if (value.blockProp && value.blockProp.name === 'heading') {
                _this.lockField = value.locked;
              }
            });
          }
        }

        /**
         * Template Locks for Email Contact Details (subject)
         */
        if ($attrs.model === 'message.template_properties.subject__withMergeTags') {
          var _foundEmailPayload2 = scCampaignsTemplateService.getEmailComponent(chosenParamId);
          var _activeEmail2 = scCampaignsTemplateService.getActiveEmail(_foundEmailPayload2);

          if (_activeEmail2) {
            _this.lockField = _activeEmail2.item_attributes.template_properties.subject.locked;
          }
        }

        var getLockedFieldForSetUp = function getLockedFieldForSetUp(step) {
          if (step === 'landing') {
            /* inside setup tab */
            var lockHeroBlock = scCampaignsTemplateService.getBlockByType('crowdfunding');
            var lockAboutBlock = scCampaignsTemplateService.getBlockByType('about');

            if (lockHeroBlock && $attrs.model === 'crowdfundingBlock.current.headline') {
              _this.lockField = lockHeroBlock.item_attributes.headline.locked;
            }
            if (lockHeroBlock && $attrs.checkboxModel === 'crowdfundingBlock.current.hideHeadline') {
              _this.lockCheckboxField = lockHeroBlock.item_attributes.hideHeadline.locked;
              _this.customStyle = '28%';
            }
            if (lockAboutBlock && $attrs.model === 'aboutBlock.current.content') {
              _this.lockField = lockAboutBlock.item_attributes.content.locked;
            }
          }
          if (step === 'donation') {
            var lockDonationBlock = scCampaignsTemplateService.getBlockByType('donation');

            if (lockDonationBlock && $attrs.model === "DonationBlock.current['headline']") {
              _this.lockField = lockDonationBlock.item_attributes.headline.locked;
            }
            if (lockDonationBlock && $attrs.model === 'DonationBlock.current.description') {
              _this.lockField = lockDonationBlock.item_attributes.description.locked;
            }

            if (lockDonationBlock && $attrs.model === 'campaign.current.classy_mode_appeal') {
              _this.lockField = scCampaignsTemplateService.getCampaignCustomizationLock('classy_mode_appeal');
            }
          }
          if (step === 'thank-you') {
            var lockThankYouBlock = scCampaignsTemplateService.getBlockByType('thank-you');

            if (lockThankYouBlock && $attrs.model === "ThankYouBlock.current['headline']") {
              _this.lockField = lockThankYouBlock.item_attributes.headline.locked;
            }
            if (lockThankYouBlock && $attrs.model === "ThankYouBlock.current['supporting-message']") {
              _this.lockField = lockThankYouBlock.item_attributes['supporting-message'].locked;
            }
          }
        };
        var getLockedField = function getLockedField(type) {
          var lockedBlock = scCampaignsTemplateService.getBlockByType(type);
          if (lockedBlock) {
            var fieldName = $attrs.model.split('.').splice(-1)[0];
            if (_.includes(['headline', 'content', 'cta', 'subheadline', 'supportersHeadline', 'description'], fieldName)) {
              _this.lockField = lockedBlock.item_attributes[fieldName] && lockedBlock.item_attributes[fieldName].locked;
            } else if ($attrs.model === "block['supporting-message']") {
              _this.lockField = lockedBlock.item_attributes['supporting-message'] && lockedBlock.item_attributes['supporting-message'].locked;
            }
          }
        };
        var blockObj = _.find(SC.blocks, { id: $stateParams.blockId });
        if (blockObj) {
          getLockedField(blockObj.type);
        } else if ($stateParams.step) {
          getLockedFieldForSetUp($stateParams.step);
        }

        /* only in case of campaign */
        if ($stateParams.step === 'fundraiser' && $attrs.model === 'campaign.current.default_page_post_body') {
          _this.lockField = scCampaignsTemplateService.getCampaignSettingLock('default_page_post_body');
        } else if ($stateParams.step === 'team' && $attrs.model === 'campaign.current.default_team_post_body') {
          _this.lockField = scCampaignsTemplateService.getCampaignSettingLock('default_team_post_body');
        }
      }
      if (_this.lockField) {
        tmpModel = _this.model;
      }

      _.defaultsDeep(_this, DEFAULTS);
      // FRS-7475: the textarea froala element was taking a second to load the ng-model,
      // and that change between NaN to the prepopulated model was triggering the $dirty
      // this part grabs the textarea element
      _this.element = $element.find('textarea').data();
      // this part sets the init flag to the correct part of the sequence
      _this.init = 1;
    };

    this.$doCheck = function () {
      // if there is a prepopulated model (including empty str)
      // and the ngModelController has loaded BUT it has not loaded the data itself,
      // set pristine to false in order to disable $dirtying and $pristining
      if (_this.init === 1 && _.get(_this.element, '$ngModelController', false)) {
        _this.element.$ngModelController.$pristine = false;
        _this.init -= 1;
      }

      // if the above step has been completed and the model has been loaded properly as the
      // modelValue, we trigger $setPristine in order to get the $dirty/$pristine triggers
      // working again
      if (_this.init === 0 && _this.element.$ngModelController.$modelValue === _this.modelGetterSetter) {
        _this.element.$ngModelController.$setPristine();
        _this.init -= 1;
      }
    };

    this.modelGetterSetter = function (val) {
      if (arguments.length) {
        if (this.lockField) {
          tmpModel = val;
        } else {
          this.model = val;
        }
        return null;
      } else {
        if (this.lockField) {
          return tmpModel;
        }
        return this.model;
      }
    };
  }]
});
})();